export function GridViewFilterHide() {
    $('.grid-filter').each((i, el) => {
        $(el).next().children().hide();
        $(el).hide();
    })
}